import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";
import { loadAllCalendarLocales } from "./CalendarTranslate";

// Definición de un componente funcional
const FormFilterMultiSelect = ({ showCalendar = false, newDateValues, selectedUser, setSelectedUser, users, rangeDate }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const [ date, setDate] = useState( rangeDate[0] === null ? null : rangeDate);
    const [localesReady, setLocalesReady] = useState(false);

    const setRangeDate = (value) => {
        if (value) {
            setDate(value)
            newDateValues(value)
        }
        else {
            newDateValues([])
            setDate(null)
        }
    }

    useEffect(() => {
        loadAllCalendarLocales(t);
        setLocalesReady(true);

    }, [t]);

    if (!localesReady) return null; // Espera a registrar los locales

    return (
        <div className="filter-container flex flex-wrap text-white">
            <Dropdown
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.value)}
                options={users}
                className="mimetika-dropdown border mr-4 my-2"
                panelClassName="mimetika-dropdown-panel"
            />
            { showCalendar && (
                <Calendar
                    value={ date }
                    onChange={(e) => setRangeDate(e.value)}
                    selectionMode="range"
                    placeholder={t('Filter by date')}
                    showIcon
                    icon="pi pi-chevron-down"
                    dateFormat="dd.mm.yy"
                    className="w-56 mr-4 my-2 "
                    showButtonBar
                    hideOnRangeSelection={true}
                    locale={currentLanguage}
                />
            )}
        </div>
    );
}

export default FormFilterMultiSelect;
